export default __webpack_public_path__ + "static/media/FinanceIncome.77b1ca7f.png";